import { render, staticRenderFns } from "./product-muti-select-modal.vue?vue&type=template&id=61b4cf6a&"
import script from "./product-muti-select-modal.vue?vue&type=script&lang=js&"
export * from "./product-muti-select-modal.vue?vue&type=script&lang=js&"
import style0 from "./product-muti-select-modal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports